import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  map,
  share,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import { OperationalLimitAction } from './operational-limit.action';
import { OperationalLimitService } from '../../services/operational-limit/operational-limit-api.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces/app-state.interface';

@Injectable()
export class OperationalLimitEffects {
  /**
   * Busca os termos de aceite de Limite Operacional do usuário atual
   * Combina contexto de autenticação para recuperar o CBLC do usuário
   * @effect getAcceptanceTerm$
   */
  getAcceptanceTerm$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OperationalLimitAction.getAcceptanceTerm),
      withLatestFrom(
        this.store.select((authStore) => authStore.authentication)
      ),
      switchMap(([_, authStore]) => {
        const cblc = authStore.currentUser.cblc;
        return this.operationalLimitService.getUserAcceptanceTerm(cblc).pipe(
          map((result) => {
            if (result) {
              return {
                type: OperationalLimitAction.getAcceptanceTermSuccess,
                payload: result,
              };
            }
          }),
          catchError((error) => {
            return of({
              type: OperationalLimitAction.getAcceptanceTermError,
              payload: error,
            });
          })
        );
      }),
      share()
    )
  );

  acceptTerm$ = createEffect(() =>
  this.actions$.pipe(
    ofType(OperationalLimitAction.acceptTerm),
    switchMap((action: any) => {
      return this.operationalLimitService.setUserAcceptanceTerm(action.payload).pipe(
        map((result) => {
          if (this.isBusinessError(result)) {
            return {
              type: OperationalLimitAction.acceptTermError,
              payload: result
            };
          }
          if (result) {
            return {
              type: OperationalLimitAction.acceptTermSuccess,
              payload: result
            };
          }
          return {
            type: OperationalLimitAction.acceptTermSuccess
          };
        }),
        catchError((error) => {
          return of({
            type: OperationalLimitAction.acceptTermError,
            payload: error,
          });
        })
      );
    }),
    share()
  )
  );

  rejectTerm$ = createEffect(() =>
  this.actions$.pipe(
    ofType(OperationalLimitAction.rejectTerm),
    switchMap((action: any) => {
      return this.operationalLimitService.rejectUserAcceptanceTerm(action.payload).pipe(
        map((result) => {
          if (this.isBusinessError(result)) {
            return {
              type: OperationalLimitAction.rejectTermError,
              payload: result
            };
          }
          if (result) {
            return {
              type: OperationalLimitAction.rejectTermSuccess,
              payload: result
            };
          }
          return {
            type: OperationalLimitAction.rejectTermSuccess
          };
        }),
        catchError((error) => {
          return of({
            type: OperationalLimitAction.rejectTermError,
            payload: error,
          });
        })
      );
    }),
    share()
  )
  );



  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private operationalLimitService: OperationalLimitService
  ) {}

  private isBusinessError(result: any): boolean {
    return !!result && (result.ok === false || result.hasError === true);
  }
}
